import React from "react";
import Marquee from "react-fast-marquee";

const TransactionTicketNumbers = React.memo(
  ({ ticketNumbers }) => {
    if (Array.isArray(ticketNumbers) && ticketNumbers.length > 0) {
      return (
        <Marquee pauseOnHover gradient={false} speed={50}>
          {[...ticketNumbers, ""].join(" _ ")}
        </Marquee>
      );
    }
    return <span>-</span>;
  },
  (prevProps, nextProps) => {
    const prev = prevProps.ticketNumbers;
    const next = nextProps.ticketNumbers;
    if (prev === next) return true;
    if (!Array.isArray(prev) || !Array.isArray(next)) {
      return prev === next;
    }
    if (prev.length !== next.length) return false;
    for (let i = 0; i < prev.length; i++) {
      if (prev[i] !== next[i]) return false;
    }
    return true;
  }
);

export default TransactionTicketNumbers;
